import React from "react"
import {
    Autocomplete,
    Box,
    Chip,
    TextField,
    Typography,
} from "@mui/material"

const inputStyle = {
    '&.MuiInputBase-root': {
        height: 38,
        padding: '0 8px',
    },
    '& input': {
        padding: '8px 0',
        fontSize: '13px',
    },
}

const MultiSelectChipsBelow = ({
    label,
    placeholder,
    options = [],
    value = [],
    onChange,
    readOnly = false,
}) => {
    const handleDelete = (optionToRemove) => {
        const updated = value.filter((val) => val !== optionToRemove)
        onChange(updated)
    }

    return (
        <Box sx={{ mb: 2 }}>
            {label && (
                <Typography variant="body2" sx={{ fontWeight: 500, mb: 0.5 }}>
                    {label}
                </Typography>
            )}
            <Autocomplete
                multiple
                options={options}
                value={value}
                onChange={(e, newValue) => !readOnly && onChange(newValue)}
                renderTags={() => null}
                renderInput={(params) => (
                    <TextField
                        {...params}
                        placeholder={placeholder}
                        variant="outlined"
                        InputProps={{
                            ...params.InputProps,
                            sx: inputStyle,
                            readOnly: readOnly,
                        }}
                        disabled={readOnly}
                    />
                )}
                slotProps={{
                    paper: {
                        sx: {
                            '& .MuiAutocomplete-option': {
                                fontSize: '13px',
                            },
                            '& .MuiAutocomplete-groupLabel': {
                                fontSize: '13px',
                                fontWeight: 600,
                            },
                        },
                    },
                }}
                sx={{ p: 0 }}
                disabled={readOnly}
            />

            {value.length > 0 && (
                <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1, mt: 1 }}>
                    {value.map((option) => (
                        <Chip
                            key={option}
                            label={option?.label ?? option}
                            onDelete={readOnly ? undefined : () => handleDelete(option)}
                            size="small"
                            // Optionally gray out chip in readOnly mode:
                            color={readOnly ? "default" : "primary"}
                            variant={readOnly ? "outlined" : "filled"}
                        />
                    ))}
                </Box>
            )}
        </Box>
    )
}

export default MultiSelectChipsBelow
